// removed by extract-text-webpack-plugin
module.exports = {"settingsBackground":"_3LWYu4G689FPzn7kMkW-w2","settingsContainer":"_1q0vZ_RGq2wyLosSvzzLRx","settingsContainerMobile":"_1kYhfx5xjb7SXKwV13fQPc","settingsContainerCenter":"_1l8VxVtCHhIeOLrFZKXD8Y","topContainer":"_2xG0eQIu4qHIkrxsA8zbdH","titleContainer":"_1EL8R-7Zo7xX9aIk5JZ0ss","title":"_2sUzwUIEPI0P9dPmhEBtuG","closeButton":"_2TuVWXIFEhxTtr6gij3tu","content":"mU1AXJGpQmHas2N1cokGh","setVideoVisibilityButtonContainer":"_2SgjrPy8fpn2TSyluNHQIP","setVideoVisibilityButtonText":"_1HpakdsP8CBaus95OtIbXr","setVideoVisibilityButtonCheckbox":"_203B9bqzoGBslcNTGYnL1d"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/settings.css
// module id = 1052
// module chunks = 0